import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generateDescription } from '../../api/documentAPI';
import { useNotification } from '../../context/NotificationContext';
import { NotificationType } from '../../enums/NotificationType';
import { formatDateTime } from '../../utils/dateFormat';

// Popis obsahu priečinka pre AI agenta (chat „Všetky moje priečinky“ podľa neho vyberá, kde hľadať).
// Generuje sa automaticky; ručná úprava ho zamkne (automatika ho potom neprepíše), zámok sa dá zrušiť.
// envId = upravovaný priečinok (tlačidlo „Vygenerovať návrh“); pri novom priečinku nie je.
const FolderDescriptionField = ({ description, locked, updatedAt, envId, onChange }) => {
    const [t, i18n] = useTranslation('global');
    const { showNotification } = useNotification();
    const [generating, setGenerating] = useState(false);

    const handleGenerate = async () => {
        setGenerating(true);
        try {
            const res = await generateDescription(envId);
            if (res?.Status === 'OK' && res.Data?.Description) {
                onChange({ description: res.Data.Description, descriptionLocked: false });
            } else {
                const msg = res?.Data?.Messages?.[0]?.Message;
                showNotification({ message: msg ? t(msg) : t('errorOccured'), type: NotificationType.Error });
            }
        } catch (e) {
            showNotification({ message: t('errorOccured'), type: NotificationType.Error });
        } finally {
            setGenerating(false);
        }
    };

    return (
        <div className="folder-description">
            <div className="folder-description-head">
                <label htmlFor="folder-description-input">{t('folderDescription')}</label>
                {envId != null && (
                    <button type="button" className="folder-description-generate" disabled={generating}
                            onClick={handleGenerate}>
                        <span className={`material-symbols-outlined${generating ? ' spin' : ''}`}>
                            {generating ? 'progress_activity' : 'auto_awesome'}
                        </span>
                        {generating ? t('generatingDescription') : t('generateDescription')}
                    </button>
                )}
            </div>
            <textarea
                id="folder-description-input"
                className="folder-description-input"
                rows={4}
                maxLength={2000}
                value={description || ''}
                placeholder={t('folderDescriptionPlaceholder')}
                onChange={(e) => onChange({ description: e.target.value, descriptionLocked: true })}
            />
            <div className="folder-description-foot">
                <label className="folder-description-auto">
                    <input type="checkbox" checked={!locked}
                           onChange={(e) => onChange({ descriptionLocked: !e.target.checked })} />
                    {t('folderDescriptionAuto')}
                </label>
                {updatedAt && (
                    <span className="folder-description-updated">
                        {t('folderDescriptionUpdated')}: {formatDateTime(updatedAt.endsWith('Z') ? updatedAt : `${updatedAt}Z`, i18n.language)}
                    </span>
                )}
            </div>
            <span className="env-type-hint">{t('folderDescriptionHint')}</span>
        </div>
    );
};

export default FolderDescriptionField;
